import useContentProtection from "../hooks/useContentProtection";

// Wraps public-facing pages to apply print/screenshot/copy deterrents.
// Do NOT use on the headless-Chromium print routes (official PDF generation).
export default function ProtectedContent({ children, enabled = true }) {
  useContentProtection(enabled);
  return children;
}
